<template>
    <div
        :class="[
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: pageStore.openMenu },
    ]"
        id="sidebar-area"
    >
        <div class="logo position-absolute start-0 end-0 top-0 bg-black">
            <router-link
                to="/"
                class="d-flex align-items-center text-white text-decoration-none"
            >
                <!--        <img src="../../assets/images/favicon.png" alt="logo-icon"/>-->
                <span class="fw-bold ms-10">FELIX TIME MANAGEMENT</span>
            </router-link>
            <div class="border-bottom"></div>
            <button
                class="sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0"
                @click="handleOpenBurgerMenu"
            >
                <i class="ph-duotone ph-caret-double-right"></i>
            </button>
        </div>
        <div class="sidebar-menu">
            <ul
                class="sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion"
                id="sidebarNavAccordion"
            >
                <li class="sub-title sidebar-nav-item">
                    <span class="d-block text-uppercase fw-medium">Menus</span>
                </li>
                <li class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
                    v-if="sessionStore.checkMenuPermission('attendance-today') || sessionStore.checkMenuPermission('attendance-request') || sessionStore.checkMenuPermission('attendance-manual') || sessionStore.checkMenuPermission('attendance-checkin')">
                    <a
                        href="#"
                        class="accordion-button rounded-0 shadow-none bg-transparent d-block"
                        :class="{ collapsed: openMenu !== 'attendance' }"
                        @click.prevent="toggleMenu('attendance')"
                    >
                        <i class="flaticon-date"></i>
                        <span class="title">Attendance</span>
                    </a>
                    <div
                        class="accordion-collapse collapse"
                        :class="{ show: openMenu === 'attendance' }"
                    >
                        <div class="accordion-body">
                            <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                                <li class="sidebar-sub-menu-item" v-if="sessionStore.checkMenuPermission('attendance-today')">
                                    <router-link to="/" class="sidebar-sub-menu-link">
                                        Today
                                    </router-link>
                                </li>
                                <li class="sidebar-sub-menu-item" v-if="sessionStore.checkMenuPermission('attendance-request')">
                                    <router-link
                                        to="/request-attendance"
                                        class="sidebar-sub-menu-link"
                                    >
                                        Request
                                    </router-link>
                                </li>
                                <li class="sidebar-sub-menu-item" v-if="sessionStore.checkMenuPermission('attendance-manual')">
                                    <router-link
                                        to="/manual-attendance"
                                        class="sidebar-sub-menu-link"
                                    >
                                        Manual
                                    </router-link>
                                </li>
                                <li class="sidebar-sub-menu-item" v-if="sessionStore.checkMenuPermission('attendance-checkin')">
                                    <router-link
                                        to="/request-checkin"
                                        class="sidebar-sub-menu-link"
                                    >
                                        CheckIn
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li class="sidebar-nav-item" v-if="sessionStore.checkMenuPermission('ot-today')">
                    <router-link to="/ot-request" class="sidebar-nav-link d-block">
                        <i class="flaticon-date"></i>
                        <span class="title">OT</span>
                    </router-link>
                </li>
                <li class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
                    v-if="sessionStore.checkMenuPermission('leave-list') || sessionStore.checkMenuPermission('leave-entitlement-view') || sessionStore.checkMenuPermission('leave-type-manage')">
                    <a
                        href="#"
                        class="accordion-button rounded-0 shadow-none bg-transparent d-block"
                        :class="{ collapsed: openMenu !== 'leave' }"
                        @click.prevent="toggleMenu('leave')"
                    >
                        <i class="flaticon-edit"></i>
                        <span class="title">Leave</span>
                    </a>
                    <div
                        class="accordion-collapse collapse"
                        :class="{ show: openMenu === 'leave' }"
                    >
                        <div class="accordion-body">
                            <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                                <li class="sidebar-sub-menu-item" v-if="sessionStore.checkMenuPermission('leave-list')">
                                    <router-link to="/leave-request" class="sidebar-sub-menu-link">
                                        Request
                                    </router-link>
                                </li>
                                <li class="sidebar-sub-menu-item" v-if="sessionStore.checkMenuPermission('leave-list')">
                                    <router-link to="/leave-approved" class="sidebar-sub-menu-link">
                                        Approved
                                    </router-link>
                                </li>
                                <li class="sidebar-sub-menu-item" v-if="sessionStore.checkMenuPermission('leave-entitlement-view')">
                                    <router-link to="/leave-entitlement" class="sidebar-sub-menu-link">
                                        Entitlement
                                    </router-link>
                                </li>
                                <li class="sidebar-sub-menu-item" v-if="sessionStore.checkMenuPermission('leave-type-manage')">
                                    <router-link to="/leave-settings" class="sidebar-sub-menu-link">
                                        Settings
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li class="sidebar-nav-item" v-if="sessionStore.checkMenuPermission('employee')">
                    <router-link to="/employee" class="sidebar-nav-link d-block">
                        <i class="flaticon-setting"></i>
                        <span class="title">Employee</span>
                    </router-link>
                </li>
                <li class="sidebar-nav-item" v-if="sessionStore.checkMenuPermission('holiday-list')">
                    <router-link to="/holiday" class="sidebar-nav-link d-block">
                        <i class="flaticon-edit"></i>
                        <span class="title">Holiday</span>
                    </router-link>
                </li>
                <li class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
                    v-if="sessionStore.checkMenuPermission('report-attendance') || sessionStore.checkMenuPermission('report-leave')">
                    <a
                        href="#"
                        class="accordion-button rounded-0 shadow-none bg-transparent d-block"
                        :class="{ collapsed: openMenu !== 'report' }"
                        @click.prevent="toggleMenu('report')"
                    >
                        <i class="flaticon-date"></i>
                        <span class="title">Report</span>
                    </a>
                    <div
                        class="accordion-collapse collapse"
                        :class="{ show: openMenu === 'report' }"
                    >
                        <div class="accordion-body">
                            <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                                <li class="sidebar-sub-menu-item" v-if="sessionStore.checkMenuPermission('report-attendance')">
                                    <router-link
                                        to="/attendance-report"
                                        class="sidebar-sub-menu-link"
                                    >
                                        Attendance
                                    </router-link>
                                </li>
                                <li class="sidebar-sub-menu-item" v-if="sessionStore.checkMenuPermission('report-leave')">
                                    <router-link to="/leave-report" class="sidebar-sub-menu-link">
                                        Leave
                                    </router-link>
                                </li>
                                <li class="sidebar-sub-menu-item" v-if="sessionStore.checkMenuPermission('report-attendance')">
                                    <router-link to="/ot-report" class="sidebar-sub-menu-link">
                                        OT
                                    </router-link>
                                </li>
                                <li class="sidebar-sub-menu-item" v-if="sessionStore.checkMenuPermission('report-attendance')">
                                    <router-link to="/checkin-report" class="sidebar-sub-menu-link">
                                        Check In
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li class="sidebar-nav-item" v-if="sessionStore.checkMenuPermission('user')">
                    <router-link to="/user-permission" class="sidebar-nav-link d-block">
                        <i class="flaticon-user-3"></i>
                        <span class="title">User & Permission</span>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup lang="ts">
import { usePageStore } from '@/store/page'
import { ref, watch } from 'vue'
import { useSessionStore } from '@/store/sessions'
import { useRoute } from 'vue-router'

const pageStore = usePageStore()
const sessionStore = useSessionStore()
const route = useRoute()

const openMenu = ref<string>('')

const menuRouteMap: Record<string, string> = {
    '/': 'attendance',
    '/request-attendance': 'attendance',
    '/manual-attendance': 'attendance',
    '/request-checkin': 'attendance',
    '/leave-request': 'leave',
    '/leave-approved': 'leave',
    '/leave-entitlement': 'leave',
    '/leave-settings': 'leave',
    '/attendance-report': 'report',
    '/leave-report': 'report',
    '/ot-report': 'report',
    '/checkin-report': 'report',
}

const setMenuFromRoute = () => {
    openMenu.value = menuRouteMap[route.path] || ''
}

setMenuFromRoute()

watch(() => route.path, setMenuFromRoute)

const toggleMenu = (menu: string) => {
    openMenu.value = openMenu.value === menu ? '' : menu
}

watch(() => pageStore.openMenu, () => {})

const handleOpenBurgerMenu = () => {
    pageStore.toggleOpenMenu()
}

</script>

<style scoped>

</style>
